import EmailVerifyForm from "../components/EmailVerifyForm";

export default function EmailVerification() {
  return (
    <div className="relative z-10 w-full max-w-md px-6 py-40">
      <div className="flex justify-center mb-8">
        <img src="/logo_email.svg" alt="email" className="w-17 h-17" />
      </div>
      <EmailVerifyForm />
    </div>
  );
}
